import { createSlice } from '@reduxjs/toolkit';

/*
 * This is where we keep track of "Emergency Contacts" of clients
 *
 * The structure is
 * {
 *   <clientIdI>: [
 *     {
 *       personId: <pId>,
 *       relationship: '<something>',
 *     },
 *     {
 *       personId: <pId>,
 *       relationship: '<something>',
 *     },
 *     ...
 *   ],
 *   <clientIdJ>: [
 *     {
 *       personId: <pId>,
 *       relationship: '<something>',
 *     },
 *     {
 *       personId: <pId>,
 *       relationship: '<something>',
 *     },
 *     ...
 *   ],
 *   ...
 * }
 */

const initialState = {};

const haveListForPerson = (state, personId) => Object.keys(state).indexOf(personId.toString()) >= 0;

export const emergencyContactsSlice = createSlice({
  name: 'emergencyContacts',
  initialState: initialState,
  reducers: {
    clearEmergencyContacts: () => {
      return initialState;
    },

    addOrUpdateContacts: (state, action) => {
      const { clientId, contacts } = action.payload;
      if (!haveListForPerson(state, clientId)) {
        return { ...state, [clientId]: contacts };
      }
      let listOfContacts = state[clientId];
      contacts.forEach((contact) => {
        if (listOfContacts.some((ctct) => ctct.personId === contact.personId)) {
          const prunedList = listOfContacts.filter((ctct) => ctct.personId !== contact.personId);
          listOfContacts = [...prunedList, contact];
        } else {
          listOfContacts = [...listOfContacts, contact];
        }
      });
      return { ...state, [clientId]: listOfContacts };
    },

    removeContact: (state, action) => {
      const { personId, contactId } = action.payload;
      if (haveListForPerson(state, personId)) {
        const newList = state[personId].filter((contact) => contact.personId !== contactId);
        return { ...state, [personId]: newList };
      } else {
        return state;
      }
    },
  },
});

export const { clearEmergencyContacts, addOrUpdateContacts, removeContact } = emergencyContactsSlice.actions;

export default emergencyContactsSlice.reducer;
